import { CreateSalesComponent } from './../../views/sales/create-sales/create-sales.component';
import { PosNoEnterCreditRequestReasonModalService } from './../services/pos-no-enter-credit-request-reason-modal.service';
import { Injectable } from '@angular/core';
import {
  CanDeactivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { CreditService } from 'src/app/services/credit.service';
import { CustomerIdentificationComponent } from 'src/app/views/customers/components';
import { ModalDialogType } from '../constants';
import { PosConfirmationService } from '../services/pos-confirmation.service';
import { OrderDetailsComponent } from 'src/app/views/orders/order-details/order-details.component';
import { Customer } from 'src/app/models/customer';

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateGuard
  implements CanDeactivate<CustomerIdentificationComponent>
{
  constructor(
    private creditService: CreditService,
    private confirmDialogService: PosConfirmationService,
    private noEnterCreditRequestModalService: PosNoEnterCreditRequestReasonModalService
  ) {}
  async canDeactivate(
    component: CustomerIdentificationComponent | OrderDetailsComponent | CreateSalesComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Promise<boolean> {
    const preApprove = this.creditService.getPreApprove();

    let response = true;

    const comeFromQuotationButton = this.isCustomerIdentificationComponent(component) ? component.comeFromQuotationPlanClick : false;
    const isCreatingCreditRequestFromOrderDetail = this.isOrderDetailComponent(component) ? component.isCreateCreditRequestAction : false;

    if (preApprove !== undefined) {
      if (!comeFromQuotationButton && !isCreatingCreditRequestFromOrderDetail) {
        if (!preApprove.isCreditRequestCreated) {

          const confirmDialogUserResponse = await this.showConfirmUserDialog();

          if (confirmDialogUserResponse) {
            const customer = new Customer();
            this.setCustomerCode(component, customer);

            response = await this.noEnterCreditRequestModalService.show(customer,preApprove.preApproveCode);

            if (response) {
              this.creditService.setPreApprove(undefined);
            }
            return response;

          }
          return confirmDialogUserResponse;
        }
      }
    }

    return response;
  }

  private setCustomerCode(component: CustomerIdentificationComponent | OrderDetailsComponent | CreateSalesComponent, customer: Customer) {
    if (this.isCustomerIdentificationComponent(component)) {
      customer.code = component.currentCustomer.code;
    } else {
      customer.code = component.customer.code;
    }
  }

  private async showConfirmUserDialog() {
    return await this.confirmDialogService.showAsync(
      `¡Atención!`,
      `¿Esta seguro de salir, sin ingresar una solicitud de credito?`,
      ModalDialogType.WARNING
    );
  }

  isCustomerIdentificationComponent(value: CustomerIdentificationComponent | OrderDetailsComponent | CreateSalesComponent): value is CustomerIdentificationComponent {
    return (value as CustomerIdentificationComponent).currentCustomer !== undefined;
  }

  isOrderDetailComponent(value: CustomerIdentificationComponent | OrderDetailsComponent | CreateSalesComponent): value is OrderDetailsComponent {
    return (value as OrderDetailsComponent).response !== undefined;
  }

}
